import { Fragment } from 'react';

/**
 * Translator service
 * setTranslations and setLanguage are called once
 * on application bootstrap to set translations data and language
 * t(string)  translates string or returns original string if translation is not found.
 * @type {{setTranslations, setLanguage, t}}
 */
const Translator = (function createTranslator() {
	const allTranslations = {};
	let currentLanguage = 'eng';

	function translateFn(str, ...args) {
		let ret = str;

		if (typeof ret === 'string') {
			const translatedText = allTranslations[currentLanguage]?.[str];

			ret = translatedText || str;
		}

		args.length &&
			args.map((arg, i) => {
				ret = ret.replace(`{${i + 1}}`, arg);
			});

		return ret;
	};

	translateFn.jsx = (str, ...args) => {
		let template = str;

		if (typeof template === 'string') {
			const translatedText = allTranslations[currentLanguage]?.[str];
			template = translatedText || str;
		}

		if (args.length === 0) return template;

		// Split {1},{2}...
		const parts = template.split(/(\{\d+\})/g);

		return parts.map((part) => {
			const match = part.match(/^\{(\d+)\}$/);
			if (match) {
				const argIndex = parseInt(match[1], 10) - 1;
				const replacement = args[argIndex];

				return <Fragment key={argIndex}>{replacement}</Fragment>;
			}
			return part;
		});
	};

	return {
		setTranslations(translations, language) {
			allTranslations[language] = translations;
		},
		setLanguage(lang) {
			currentLanguage = lang;
			allTranslations[currentLanguage] = allTranslations[currentLanguage] || {};
		},
		t: translateFn,
		getTranslator(language = "eng") {
			currentLanguage = language;

			return Translator.t;
		},
	};
}());

export const { t } = Translator;

export default Translator;
